import React, { Fragment, useEffect, useState } from 'react';
import { Col, Row, Card, CardBody, CardHeader } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { TextField } from '../../../shared/TextField';
import { PhoneField } from '../../auth/PhoneField';
import { CountrySelect } from '../../../shared/CountrySelect';
import { Messages } from '../../../layout/Messages/Messages';
import { ErrorMessage } from 'formik';
import { UserSelect } from '../../../shared/UserSelect';
import { getCounties, getCities } from '../../../../api/admin/neo/countiesAndCities';
import { CustomField } from '../../../../components/pages/profile/CustomField';

function CompanyInfo(props) {
  const { getErrorClass, formikProps } = props;

  const [countiesOptions, setCountiesOptions] = useState(null);
  const [selectedCounty, setSelectedCounty] = useState(null);
  const [citiesOptions, setCitiesOptions] = useState(null);

  useEffect(() => {
    getCountiesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikProps.values.companyCounty])

  useEffect(() => {
    if(selectedCounty) {
      getCitiesList(selectedCounty);
    }
  }, [selectedCounty]);

  const getCountiesList = () => {
    getCounties().then( response => {
      if (response?.data) {
        let options = [];

        response.data.forEach(county => {
          options.push({value: county, display: county});
        })

        setCountiesOptions(options);

        if (response.data.includes(formikProps.values.companyCounty)) {
          setSelectedCounty(formikProps.values.companyCounty);
        }
      }
    } );
  }

  const getCitiesList = (county) => {
    getCities({ urlParams: { county: county } }).then((response) => {
      if (response?.data && response.data.length) {
        let options = [];

        response?.data.forEach(city => {
          options.push({value: city, display: city});
        })

        setCitiesOptions(options);
      }
    });
  };

  return ( <Fragment>
      <Card id="qualified-signatures-content">
        <CardHeader>
          <FormattedMessage
            id="components.pages.orderManagement.createOrderForm.company_details"/>
        </CardHeader>
        <CardBody>
          <Row>
            <Col xs={12} sm={6} className="justify-content-between">
              <TextField
                name="companyName"
                handleBlur={formikProps.handleBlur}
                fontAwesome="faBuilding"
                onChange={event => {
                  formikProps.setFieldValue( 'companyName', event.target.value );
                }}
                value={formikProps.values.companyName}
                errorClass={getErrorClass( formikProps, 'companyName' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyName"
                  component="div"
                  data-testid="errors-companyName"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>
            <Col xs={12} sm={6}>
              <TextField
                name="companyCui"
                handleBlur={formikProps.handleBlur}
                fontAwesome="faCashRegister"
                onChange={event => {
                  formikProps.setFieldValue( 'companyCui', event.target.value );
                }}
                value={formikProps.values.companyCui}
                errorClass={getErrorClass( formikProps, 'companyCui' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyCui"
                  component="div"
                  data-testid="errors-companyCui"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <TextField
                name="companyRegistryNo"
                handleBlur={formikProps.handleBlur}
                fontAwesome="faCashRegister"
                onChange={event => {
                  formikProps.setFieldValue( 'companyRegistryNo', event.target.value );
                }}
                value={formikProps.values.companyRegistryNo}
                errorClass={getErrorClass( formikProps, 'companyRegistryNo' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyRegistryNo"
                  component="div"
                  data-testid="errors-companyRegistryNo"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>
            <Col xs={12} sm={6}>
              <TextField
                name="companyAddressLine1"
                handleBlur={formikProps.handleBlur}
                fontAwesome="faMapMarkerAlt"
                onChange={event => {
                  formikProps.setFieldValue( 'companyAddressLine1', event.target.value );
                }}
                value={formikProps.values.companyAddressLine1}
                errorClass={getErrorClass( formikProps, 'companyAddressLine1' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyAddressLine1"
                  component="div"
                  data-testid="errors-companyAddressLine1"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>

            <Col xs={12} sm={6}>
              <TextField
                name="companyAddressLine2"
                handleBlur={formikProps.handleBlur}
                fontAwesome="faMapMarkerAlt"
                onChange={event => {
                  formikProps.setFieldValue( 'companyAddressLine2', event.target.value );
                }}
                value={formikProps.values.companyAddressLine2 ? formikProps.values.companyAddressLine2 : ''}
                errorClass={getErrorClass( formikProps, 'companyAddressLine2' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyAddressLine2"
                  component="div"
                  data-testid="errors-companyAddressLine2"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>

          </Row>
          <Row>
            <Col xs={12} sm={6}>
              <PhoneField
                name="companyPhone"
                handleBlur={formikProps.handleBlur}
                onChange={event => {
                  formikProps.setFieldValue( 'companyPhone', event.target.value );
                }}
                value={formikProps.values.companyPhone}
                errorClass={getErrorClass( formikProps, 'companyPhone' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyPhone"
                  component="div"
                  data-testid="errors-companyPhone"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>
            <Col xs={12} sm={6}>
              <CustomField
                name="companyCounty"
                type='select'
                fontAwesome="faCity"
                value={ formikProps.values.companyCounty }
                onChange={
                  (event) => {
                    if (event.target.value !== formikProps.values.companyCounty) {
                      setSelectedCounty(event.target.value);
                    }

                    formikProps.setFieldValue( 'companyCounty', event.target.value );
                  }
                }
                fieldName='companyCounty'
                label="fields.companyCounty"
                showLabel={false}
                showOptionLabel={true}
                options={ countiesOptions }
                errorClass={ getErrorClass(formikProps, 'companyCounty') }
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyCounty"
                  component="div"
                  data-testid="errors-companyCounty"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>
          </Row>
          <Row className="justify-content-between">
            <Col xs={12} sm={6}>
              <CustomField
                name="companyCity"
                type='select'
                fontAwesome="faCity"
                value={ formikProps.values.companyCity }
                onChange={
                  (event) => {
                    formikProps.setFieldValue( 'companyCity', event.target.value );
                  }
                }
                fieldName='companyCity'
                label="fields.companyCity"
                showLabel={false}
                showOptionLabel={true}
                options={ citiesOptions }
                errorClass={ getErrorClass(formikProps, 'companyCity') }
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyCity"
                  component="div"
                  data-testid="errors-companyCity"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>
            <Col xs={12} sm={6}>
              <CountrySelect
                name="companyCountry"
                handleBlur={formikProps.handleBlur}
                fontAwesome="faGlobeAmericas"
                onChange={event => {
                  formikProps.setFieldValue( 'companyCountry', event.target.value );
                }}
                value={formikProps.values.companyCountry}
                errorClass={getErrorClass( formikProps, 'companyCountry' )}
              />
              <Messages
                color="danger"
                formikProps={props.formikProps}
                class="small-field-error"
                showDismiss={false}
              >
                <ErrorMessage
                  name="companyCountry"
                  component="div"
                  data-testid="errors-companyCountry"
                  className="no-input-margin field-error"
                />
              </Messages>
            </Col>

          </Row>
          <Row className="justify-content-between">
            <Col xs={12} sm={6}>
              <UserSelect
                fontAwesome="faUsers"
                label="fields.users"
                name="users"
                value={formikProps.values.userForPayment}
                onChange={(e) => {
                  let selectedUserForPayment = e.target.value;
                  if (! selectedUserForPayment) {
                    return;
                  }

                  formikProps.setFieldValue( 'userForPayment', selectedUserForPayment );
                }
                }
                users={props.users}
                formikProps={formikProps}
                getErrorClass={getErrorClass}
              />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </Fragment>
  )
}

export { CompanyInfo }
